import { Injectable, APP_INITIALIZER,Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
import { environment } from '../../../environments/environment'; //path to your environment files
import { isPlatformBrowser,isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Injectable()
export class ConfigService {

    private _config: Object
    private _env: string;

    constructor(private _http: HttpClient,
        @Inject(PLATFORM_ID) public platformId: Object) { }

    load() {
        return new Promise((resolve, reject) => {
            if (isPlatformBrowser(this.platformId)) {
            this._http.get('./assets/app/configuracion.txt').subscribe((response: any) => {
                    environment.path = response[0].path;
                    environment.pathMotor = response[0].pathMotor;
                    resolve(true);
                }
                );
            }
            if (isPlatformServer(this.platformId)) {
                resolve(true);
            }   
            
  
        });
    }
}

export function ConfigFactory(config: ConfigService) {
    return () => config.load();
}

export function init() {
    return {
        provide: APP_INITIALIZER,
        useFactory: ConfigFactory,
        deps: [ConfigService],
        multi: true
    }
}

const ConfigModule = {
    init: init
}

export { ConfigModule };